/* foil-deco.js · v1 · 2026-07-14 */
/* Rotates the background deco (puck / baseball) based on the .foil-section's
   progress through the viewport. Fully standalone — no dependency on
   foil-hover.js. Skips when reduced-motion is requested. Tune ROT for spin. */
(function () {
  var ROT = 90; // total degrees swept across the scroll pass

  function init() {
    var section = document.querySelector('.foil-section');
    if (!section) return;
    var decos = section.querySelectorAll('.foil-deco');
    if (!decos.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;
    function update() {
      var r = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var progress = (vh - r.top) / (vh + r.height);
      progress = Math.max(0, Math.min(1, progress));
      var deg = (progress - 0.5) * ROT;   // centered: ~0deg mid-scroll
      decos.forEach(function (d, i) {
        var dir = i % 2 === 0 ? 1 : -1;    // two decos counter-rotate
        d.style.setProperty('--deco-rot', (deg * dir).toFixed(1) + 'deg');
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
